var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"componentColorContainer"}},[_c('el-color-picker',{ref:"elColorPicker",staticStyle:{"visibility":"hidden"},attrs:{"popper-class":"popperClass"},on:{"active-change":_vm.activeChange},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }